import { getAvatarColor } from '../../utils/format';

const GRADIENT_VARIANTS = {
  amber:  'linear-gradient(135deg, var(--color-amber-400), var(--color-amber-700))',
  blue:   'linear-gradient(135deg, #0ea5e9, var(--color-blue-600))',
  purple: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
  green:  'linear-gradient(135deg, #10b981, #059669)',
};

const NAMED_SIZES = {
  xs: { px: 24, fontSize: 10, borderRadius: 6 },
  sm: { px: 32, fontSize: 12, borderRadius: 8 },
  md: { px: 36, fontSize: 14, borderRadius: 10 },
  lg: { px: 44, fontSize: 16, borderRadius: 12 },
  xl: { px: 56, fontSize: 20, borderRadius: 14 },
};

export function Avatar({ name = '', color = 'auto', size = 'md', shape = 'circle', style }) {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0].toUpperCase())
    .join('');

  const isNumeric = typeof size === 'number';
  const dim = isNumeric
    ? { px: size, fontSize: Math.round(size * 0.36), borderRadius: Math.round(size / 4) }
    : (NAMED_SIZES[size] ?? NAMED_SIZES.md);

  const radius = shape === 'circle' ? '50%' : `${dim.borderRadius}px`;

  let bg, textColor;
  if (color === 'auto') {
    const ac = getAvatarColor(name);
    bg = ac.bg;
    textColor = ac.text;
  } else {
    bg = GRADIENT_VARIANTS[color] ?? GRADIENT_VARIANTS.amber;
    textColor = '#fff';
  }

  return (
    <div
      style={{
        width: dim.px,
        height: dim.px,
        borderRadius: radius,
        background: bg,
        color: textColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: dim.fontSize,
        fontWeight: 800,
        flexShrink: 0,
        userSelect: 'none',
        ...style,
      }}
      aria-label={name}
    >
      {initials || '?'}
    </div>
  );
}
